import { getEffectiveUiLanguage, getL11nString, uiDirectionality } from "@/l11n/l11n";
import { LANG_MAP } from "@/lib/enums";
import { doLog } from "@/lib/globals";
import { postEvent } from "@/lib/api_controller";
import { TaaliaEvent } from "@/lib/event_types";

// NB: Builds a message object for the client-side welcome message.
export function getWelcomeMessage() {
  try {
    if (doLog()) console.log("getWelcomeMessage()");
    postEvent(TaaliaEvent.welcomeMessage);

    // Get the welcome message
    let utterance = getL11nString("welcome");

    // Make replacements in the welcome message
    const uiLangCode = getEffectiveUiLanguage();
    const uiLangName = getL11nString(LANG_MAP[uiLangCode]);
    const targetLangName = getTargetLanguage();
    while (utterance.includes("{{targetLanguage}}")) {
      utterance = utterance.replace("{{targetLanguage}}", targetLangName);
    }
    while (utterance.includes("{{sourceLanguage}}")) {
      utterance = utterance.replace("{{sourceLanguage}}", uiLangName);
    }

    // Get the user name placeholder
    const userNamePlaceholder = getL11nString("input_placeholder_name");

    // Build the message object
    const welcomeMessage = {
      senderId: "taalia",
      utterance,
      ixid: { scriptId: "fastweb", messageId: "user_name" },
      timestamp: new Date(),
      inputType: "text",
      xp: {
        input_placeholder: userNamePlaceholder,
      },
      directionality: uiDirectionality(),
      // emphasize: true,
      // replyOptions: [
      //   { selectionIntent: "continue", title: letsDoItButtonText, emphasize: true },
      // ],
    };

    return welcomeMessage;
  } catch (error) {
    console.log("Error in getWelcomeMessage():", error);
    return null;
  }
}

function getTargetLanguage() {
  const queryParamPl =
    new URLSearchParams(window.location.search).get("pl")?.toUpperCase() || null;
  switch (queryParamPl ?? "EN") {
    case "TR":
      return getL11nString("turkish");
    case "NL":
      return getL11nString("dutch");
    case "DE":
      return getL11nString("german");
    case "IT":
      return getL11nString("italian");
    case "FR":
      return getL11nString("french");
    case "ES":
      return getL11nString("spanish");
    case "PT":
      return getL11nString("portuguese");
    case "HI":
      return getL11nString("hindi");
    case "AR":
      return getL11nString("arabic");
    case "UK":
      return getL11nString("ukrainian");
    case "PL":
      return getL11nString("polish");
    case "EN":
    default:
      return getL11nString("english");
  }
}
